import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'KitchenHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "Blain's Farm & Fleet Kitchen Shop";
const subtitle = "Affordable small kitchen appliances, tableware, kitchen storage, canning supplies, cookware, bakeware and more!";

const mobileImage = "url('/assets/images/dxp/prebuilt-headers/KitchenHero_mobile.jpg')";
const tabletImage = "url('/assets/images/dxp/prebuilt-headers/KitchenHero_tablet.jpg')";
const desktopImage = "url('/assets/images/dxp/prebuilt-headers/KitchenHero_desktop.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);


return { __sfc: true,title, subtitle, mobileImage, tabletImage, desktopImage, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})